/* ============
 * Sunstudy Module
 * ============
 */

import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  actions,
  mutations,
  state: {
    showing: false,
    showActivationButton: true,
    autoplayTimeout: undefined,
    position: 0,
    seasons: [],
    seasonPosition: 0,
  },
  getters: {
    sunstudySeasons: (state, _, __, rootGetters) => state.seasons.length
      && rootGetters['exteriors/currentExterior'].sunstudy_id.map(id => state.seasons.find(season => season.id === id))
        .filter(season => season/* && season.images.length */),
    sunstudyAvailable: (state, getters) => getters.sunstudySeasons.length && state.showActivationButton,
    sunstudyMode: state => state.showing,
    sunstudyPosition: state => state.position,
    sunstudyAutoplay: state => !!state.autoplayTimeout,
    seasonPosition: state => state.seasonPosition,
    sunstudy: (state, getters) => getters.sunstudySeasons[state.seasonPosition],
  },
};

